import React from 'react';

// Translations
import translate from './Translate.js';

// Components
import * as icons from './Icons/Icons';
import { LaunchDarkly, FeatureFlag } from 'react-launch-darkly';
import { config } from '../config';

class Maintenance extends React.Component {

  render() {
    const { translation } = this.props;
    
    // Create a minimal anonymous user for LaunchDarkly
    const anonymousUser = {
      key: 'anonymous-user',
      anonymous: true
    };
    
    return(
      <LaunchDarkly clientId={config.ldApiKey} user={anonymousUser}>
        <FeatureFlag
          flagKey="maintenance-message"
          renderFeatureCallback={function(flagValue) {
            if(flagValue && typeof flagValue === 'object' && flagValue.message !== undefined){
              return(
                <main tabIndex="0" id="main-content" className="page page--error wrap">
                <div className="panel--brief">
                  <i className="page--error__icon"><icons.iconClock /></i>
      
                  <div>
                    <h1 className="panel__title">{flagValue.title || translation.heading}</h1>
                    <p>{flagValue.message || translation.message}</p>
                  </div>
                </div>
              </main>
            )
            }else{
              return (<main tabIndex="0" id="main-content" className="page page--error wrap">
                <div className="panel--brief">
                  <i className="page--error__green__icon"><icons.iconBadgeCheck /></i>
      
                  <div>
                    <h1 className="panel__title">{translation.up_heading}</h1>
                    <p>{translation.up_message}</p>
                  </div>
                </div>
              </main>);
            }
          }}
        />
       
      </LaunchDarkly>
    )
  }
}

export default translate('Maintenance')(Maintenance);


// WEBPACK FOOTER //
// ./src/app/components/Maintenance.js